module.exports = __webpack_public_path__ + "img/person-dolly-empty.d1eb5ed9.svg";